import { Alert, Link } from "@mui/material";
import { P, H1, Content } from "../recurso_literario.js";
import { useContext } from "react"
import { DomainContext } from "../../Context/Context.js";

export const VPNmake = () => {
    const { domainName, cloudName } = useContext(DomainContext)

	return(
		<Content>
			<H1> Levantando una VPN </H1>
			<P>
				El siguiente documento te indica paso a paso cómo levantar una VPN
				en tu {cloudName}
			</P>

			<h2> Creando un terminador de VPN </h2>
			<P>
				Lo primero es crear un servicio de VPN para obtener un acceso desde Internet
				que no sea a través del router de borde. Se necesita entonces obtener una arquitectura
				de red parecida a la de la siguiente imagen.
			</P>
			<P>
				<img src="/img/VPN/vpn1.png" alt="Esquema básico de VPN" />
			</P>
			<P>
				En la imagen anterior se puede observar que la VM que oficia de VPN posee una interfaz
				contra la WAN y una interfaz contra una LAN (podría ser más de una).
			</P>
			<P>
				Para crear una VM que oficie de VPN PFSense, sigue los pasos detallados en la sección
				"Panel de Gestión" => "Network" => "VPN". Lo importante acá es seleccionar un nombre
				con el que puedas identificar la VM, una o varias redes LAN a las cuales conectarlo
				y el ancho de banda que deseas para la WAN. Cualquiera de estas tres características
				las podrás cambiar más tarde.
			</P>

			<h2> Identificando las Interfaces de RED </h2>
			<P>
				Una vez desplegado el PFSense, debes ingresar por consola al mismo para definir papel
				que jugará cada interfaz de red. Una será la WAN y una o varias serásn las LAN. Depende
				de la cantidad de redes que hayas seleccionado al momento de crear el servidor. En la
				siguiente imagen puedes ver en el ejemplo que el servidor tiene dos interfaces de red.
			</P>
			<P>
				<img src="/img/VPN/vpn14.png" alt="VPN puertos de ejemplo" style={{width:"100%"}} />
			</P>
			<P>
				La interfaz con la IP 192.168.88.52 simula una IP pública (aunque claro está, no lo sea) y
				en tu caso será una IP pública real. La otra IP es privada y corresponde a una de las
				redes LAN del ejemplo. Acá es importante que tomes nota de las MAC_address y del CIDR. El
				primero lo necesitas para identificar la interfaz de red de la LAN o WAN y el segundo
				ya que necesitarás la máscara de red. En el ejemplo la máscara de red de la WAN es /24 y
				la máscara de la LAN también es /24.
			</P>

			<h2> Asignando rol a las interfaces de red </h2>
			<P>
				Una vez identificadas las interfaces, hay que configurarlas en el PFSense. Para ello debemos
				ingresar por consola.
			</P>
			<P>
				<img src="/img/Computo/VM/acc_consola.png" alt="Consola"/>
			</P>
			<P>
				La consola es un menú de texto. El primer paso es indicarle al PFSense qué interfaz será
				la WAN y cuales las LAN. La opción numérica para ello es la (1) "Assign Interfaces",
				como se aprecia en la siguiente imagen.
			</P>
			<P>
				<img src="/img/VPN/vpn12.png" alt="VPN config interfaces"/>
			</P>
			<P>
				Al presionar (1) "Assign Interfaces", te mostrará cuales son las interfaces disponibles.
				Acá es importante identificar mediante la MAC_address cual oficiará de WAN y cual de LAN.
				En la siguiente imagen se puede ver que la interfaz con MAC_address "fa:16:3e:3e:91:a9" y
				nombre de adaptador "vtnet1" deberá ser la WAN ya que es la MAC de la IP pública que
				{cloudName} nos ha entregado según vimos antes.
			</P>
			<P>
				<img src="/img/VPN/vpn13.png" alt="VPN config interfaces"/>
			</P>
			<P>
				También nos preguntará, antes de continuar, si deseamos configurar alguna VLAN. Le indicamos
				que no.
			</P>
			<P>
				Luego nos pedirá que indiquemos el nombre del adaptador que será la WAN. En el ejemplo le
				indicamos vtnet1 tal como identificamos que éste debe oficiar de WAN. Y finalmente nos pedirá
				el nombre del adaptador que será la LAN. Finalmente nos informará cómo quedarán configuradas
				las interfaces de red y nos pedirá confirmación como se puede ver en la siguiente imagen.
			</P>
			<P>
				<img src="/img/VPN/vpn17.png" alt="VPN config interfaces"/>
			</P>

			<h2> Configurar las IP en las interfaces de red </h2>
			<P>
				El siguiente paso es asignarles las IP a cada una de las interfaces de red. Se deben
				utilizar las IP asignadas por {cloudName}. En el caso de la o las LAN, se puede
				utilizar el servicio de DHCP siempre que esté configurado en la RED.
			</P>
			<P>
				Seleccionar en la consola del PFSense la opción (2) "Set Interface(s) IP address".Te pedirá
				a continuación que selecciones la Interfase. Si seleccionas la WAN, te preguntará si deseas
				configurarla mediante DHCP. Debes seleccionar no ya que no hay servicio DHCP para las
				IP públicas. A continuación te pedirá que ingreses la IP para IPV4. Coloca la IP que te
				ha asignado {cloudName}. Luego te pedirá la máscara de red. En nuestro ejemplo es "24".
				Presioná luego una vez más "ENTER" para saltear el ingreso del gateway. Te pedirá lo mismo
				pero para IPv6. Dile que no para DHCP y luego "ENTER" sin ingresar ningun valor como IP.
			</P>

			<h2> Accediendo a la interfaz WEB por primera vez </h2>
			<P>
				Podrás acceder a la interfaz WEB de tu PFSense desde otra VM que se encuentra en
				algunas de las LAN que puedan alcanzar la interfaz LAN del PFSense. Las credenciales
				son las que vienen por defecto con el PFSense.<br/><br/>
				Usuario: <b>admin</b><br/>
				Contraseña: <b>pfsense</b>
			</P>
			<P>
				La configuración de la VPN corre por tu cuenta y podrás consultar el sitio web de PFSense
				para dicha tarea.<br/><br/>

				<Link href="https://docs.netgate.com/pfsense/en/latest" target="blank">
					Ayuda PFSense
				</Link>
			</P>

			<h2> Seguridad </h2>
			<P>
				Una de las características que diferencia una VM que oficia de VPN mediante PFSense de una
				VM tradicional, es que en la segunda no se pueden activar las políticas de seguridad de
				los puertos WAN y LAN. La seguridad en dichos puertos corre entonces por cuenta de la
				configuración en el mismo PFSense.
			</P>

			<h2> Rutas </h2>
			<P>
				Para aquellas VM que se desea el tráfico salga por la VPN, será necesario que se configuren
				adecuadamente las rutas en dichas VM.
			</P>
		</Content>
	)
}

export const VPNIntro = () => {
    const { domainName, cloudName } = useContext(DomainContext)

	return(
		<Content>
			<H1> VPN mediante PFSense </H1>
			<P>
				Te ofrecemos implementar una VPN mediante PFSense. {cloudName} te permite
				desplegar para ello de forma simple una VM que oficia de PFSense. Sigue
				siendo una VM pero con la característica de tener una interfaz de red directamente
				en una red con direccionamiento público. A diferencia de las VM tradicionales
				de {cloudName} que solo pueden tener interfaces en redes privadas y a las cuales
				se les puede attachar una IP pública.
			</P>
			<P>
				La segunda diferencia importante es que las VM de PFSense no pueden tener la
				seguridad del puerto activada y no pueden asignárseles Grupos de Seguridad (Ver
				Grupos de Seguridad en la sección de Networking). Será responsabilidad tuya
				configurar correctamente el PFSense en lo que respecta a la seguridad
			</P>

			<h2> Listar las VPN que implementan PFSense </h2>
			<P>
				Para listar las VM que tenés en el proyecto en el que te encontrás situado,
				debés dirigirte en el menú de la izquierda a Networking {">"} VPN PFSense. Se te
				presentará el siguiente listado.
			</P>
			<P>
				<img src="/img/VPN/vpn2.png" alt="listado VPN" style={{width:"100%"}} />
			</P>

			<P>
				<b>NOMBRE</b> El nombre de la VPN.<br/><br/>
				<b>ESTADO</b> Determina el estado en el que se encuentra la VM. Generalmente lo
				verás en estado "Desplegado". Si se está realizando alguna acción sobre la VM
				verás el siguiente indicador: <img src="/img/Computo/VM/PP3.png" alt="indicador de accion en curso"/>.
				<br/><br/>
				<b>CONDICIÓN</b> Es el estado del recurso. Si indica "Desplegada" es que la VM está
				lista para ser utilizada.<br/><br/>
				<b>IP pública</b> Es la IP que la VM en la cual se implementa PFSense, ha tomado en
				su interfaz de la red con direccionamiento público. <br/><br/>
			</P>

			<P>
				Al hacer click sobre cualquiera de las filas del listado, estarás seleccionando la VM
				y pasarás a la pantalla con más información y la posibilidad de realizar ciertas
				acciones sobre ella.
			</P>

			{/************************************************************************************/}
			<h2> Visualizando información de la VM que implementa PFSense </h2>
			<P>
				En esta pantalla encontrarás toda la información necesaria de tu VM. En la parte
				superior tenés un menú para navegar.
			</P>

			<P>
				<img src="/img/VPN/vpn6.png" alt="Solapas VM" style={{width:"100%"}}/>
			</P>
			<P>
				El ícono <img src="/img/home.png" alt="indicador de accion en curso"/>
				te redirige a la pantalla principal donde se listan todas las VM que implementan PFSense.
			</P>

			<h3>Sección Detalles</h3>

			<P>
				Se muestran los detalles de la VM que implementa PFSense.
			</P>
			<P>
				<img src="/img/VPN/vpn11.png" alt="Solapas PFSense"/>
			</P>
			<P>
				<b>NOMBRE:</b> El nombre de la VM. El lápiz a la derecha del nombre permite cambiar el mismo.<br/><br/>
				<b>UUID:</b> Es un identificador único. Si tenés algún problema podés contactar al soporte
				de {domainName} y utilizar este UUID o el NOMBRE para que nuestros técnicos
				identifiquen la VM.<br/><br/>
				<b>ENDENDIDA:</b> Indica si la VM se encuentra "encendida" o "apagada".<br/><br/>
				<b>ESTADO:</b> Indica si la VM se encuentra desplegada o realizando alguna tarea.<br/><br/>
				<b>IP PÚBLICA:</b> La IP que ha tomado la interfaz que conecta la VM con la red de
				direccionamiento público.<br/><br/>
			</P>

			<h3>Sección Consumos</h3>

			<P>
				Se muestra el precio por hora de la VM que implementa PFSense, el costo acumulado hasta el momento
				y la proyección a fin de mes del costo.
			</P>
			<P>
				<img src="/img/VPN/vpn7.png" alt="Consumos"/>
			</P>

			<h2>Sección Puertos de Red</h2>
			<P>
				Se muestran un listado de los puertos a los cuales está conectada la VM.
			</P>
			<P>
				<img src="/img/VPN/vpn8.png" alt="Redes" style={{width:"100%"}}/>
			</P>

			<P>
				Las columnas del listado son las siguientes:<br/><br/>
				<b>RED</b> La red a la cual está conectado el puerto. No es un valor que puedas cambiar. <br/><br/>
				<b>DIRECCION MAC</b> La dirección MAC del puerto. No es un valor que puedas cambiar.<br/><br/>
				<b>IP</b> La IP privada del puerto según la red a donde lo has conectado.<br/><br/>
				<b>ESTADO</b> El estado del puerto. Los estados posibles son Conectado | Desconectado<br/><br/>
			</P>

			{/************************************************************************************/}
			<h2>Agregar una VM que implementa PFSense</h2>
			<P>
				Para agregar una nueva VM que implementa PFSense, tenés que utilizar el botón Agregar
				de la parte superior izquierda de la pantalla desde donde podés visualizar las VM que
				tenés en tu proyecto. Tené en cuenta que la VM se desplegará en el proyecto en el que
				te encontrás actualmente.
			</P>
			<P>
				<img src="/img/Computo/VM/CVMachine_AddMachine.png"
					 alt="Agregar VM Botón"/>
			</P>
			<P>
				Esto te presentará el siguiente asistente para crear una nueva VM que implementa PFSense.
			</P>
			<P>
				<img src="/img/VPN/vpn3.png" alt="Alta 1" style={{width:"100%"}} />
			</P>
			<P>
				En la parte izquierda encontrarás el presupuesto que se irá modificando
				de acuerdo con la configuración que elijas en las distintas secciones del alta.
			</P>
			<P>
				El precio de cargos por hora se compone de un monto por el uso de CPU, RAM y almacenamiento
				(2 VCPU, 2GM RAM, 50GB de almacenamiento respectivamente) y el ancho de banda seleccionado. El
				ancho de banda podrás cambiarlo posteriormente. Las características de CPU, RAM y espacio
				de almacenamiento no pueden modificarse de momento. Pero son los valores necesarios para
				que puedas utilizar la VM como un terminador de VPN sin inconvenientes.
			</P>

			<h3>Red</h3>
			<P>
				<img src="/img/VPN/vpn4.png" alt="alta VM paso 4" style={{width:"100%"}}/>
			</P>

			<P>
				Las VM que ofician de VPN mediante PFSense se instancian con una interfaz en una red
				con direccionamiento público y la IP es asignada aleatoriamente.
			</P>
			<P>
				Deberás seleccionar al menos una red LAN en la cual obtener una interfaz de red con
				direccionamiento privado.
			</P>
			<P>
				Podés optar por indicar la IP que deseas que tenga la VM en la red o que se asigne
				una por protocolo DHCP. Si especificás la IP, ésta debe ser válida para la red o
				de lo contrario obtendrás un error cuando se dispare el proceso que crea la VM
				resultando en la no creación de la misma.
			</P>
			<P>
				Una vez seleccionada al menos una red, se habilitará el botón "Siguiente" en
				la parte inferior derecha de la pantalla para que pases al siguiente paso.
			</P>
			<h3>Confirmar y crear</h3>
			<P>
				El último paso es visualizar la configuración que fuiste realizando y confirmarla
				para que se dispare la creación de la VM. Podrás volver sobre tus pasos con el botón
				"Anterior" en la esquina inferior izquierda para corregir cualquiera de las
				configuraciones.
			</P>
			<P>
				<img src="/img/VPN/vpn5.png" alt="alta PFSense paso 5" style={{width:"100%"}}/>
			</P>

			<P>
				Una vez lanzada la creación de la VM, comenzará el proceso que podrás ver cuando
				finaliza en el desplegable de tareas.
			</P>
			<br/><br/>

		</Content>
	)
}

export const VPNActions = () =>{
	const { domainName, cloudName } = useContext(DomainContext)

    return(
		<Content>
			<H1> Acciones sobre una VPN </H1>
			<P>
				El panel en la parte inferior de la pantalla te presentará las
				acciones que podrás realizar sobre la VM que implementa la VPN mediante PFSense.
			</P>
			<img src="/img/VPN/vpn9.png" alt="Acciones de VPN" style={{width:"30%"}} />
			<P>
				A continuación, se detalla cada acción
			</P>

			<h2> Detener/Encender </h2>
			<P>
				<img src="/img/Computo/VM/acc_prender.png" alt="Prender VM"/>
				<img src="/img/Computo/VM/acc_apagar.png" alt="Apagar VM"/>
			</P>
			<P>
				Permiten detener y encender la VM que implementa la VPN. El apagado se realiza
				desde el S.O. por lo cual los servicios se irán apagando correctamente. Este botón
				cambia dependiendo del estado de la VM. Si está encendida se presenta el botón de
				apagado. Si está apagada se presenta el botón de encendido.
			</P>
			<P> Una VM que implementa VPN mediante PFSense no contabiliza cargos por hora de CPU,
				RAM y ancho de banda cuando se encuentra apagada. El disco que la sustenta si
				continua generando cargos aun cuando la VM se encuentre apagada.
			</P>

			<h2> Consola </h2>
			<P>
				<img src="/img/Computo/VM/acc_consola.png" alt="Prender o apagar VM"/>
			</P>
			<P>
				Permite acceder a la consola del S.O.
			</P>

			<h2> Ancho de Banda </h2>
			<P>
				<img src="/img/VPN/vpn10.png" alt="Escalar Ancho de Banda"/>
			</P>
			<P>
				Permite cambiar el ancho de banda de la interfaz WAN de la VM que implementa
				PFSense. Solo se puede modificar el ancho de banda de la WAN. Los anchos de banda
				de los puertos a las redes LAN siempre serán lo máximo que el sistema ofrezca.
			</P>
			<P>
				En ancho de banda no genera cargos por hora cuando la VM se encuentra
				apagada.
			</P>

			<P>
				Al presionar el botón se te presentará una ventana donde podrás
				constatar el ancho de banda actualmente contratado y cambiarlo por
				otroa ncho de banda.
			</P>

			<h2> Eliminar </h2>
			<P>
				<img src="/img/Computo/VM/acc_eliminar.png" alt="Eliminar VM"/>
			</P>
			<P>
				Permite eliminar la VM que implementa PFSense. Se presentará una ventana
				donde deberás confirmar la acción de eliminación. La eliminación de una
				VM no tiene marcha atrás así que deberás estar muy seguro.

				La eliminación de la VM no incluye sus volúmenes de datos. Si querés además
				eliminarlos, deberás ir a la sección de volúmenes y eliminarlos desde allí.

				Los puertos de red serán eliminados liberando las IP privadas. La IP
				pública de la WAN también será eliminada. Al crear una nueva VM con PFSense,
				no se asegura que se asigne nuevamente la misma IP pública.
			</P>

			<h2> Mover de Proyecto </h2>
			<P>
				<img src="/img/Computo/VM/acc_mover.png" alt="Eliminar VM"/>
			</P>
			<P>
				Permite mover la VM desde el proyecto donde está a otro proyecto. Al mover
				una VM a otro proyecto, también se moverán de proyecto el disco de la misma.

				Al presionar el botón, se te presentará una ventana donde deberás indicar el
				proyecto destino y luego confirmar la acción.
			</P>
		</Content>
	)
}
